import React from "react";

const Summary = () => {
  return (
    <div className="flex flex-col mb-10 gap-y-4">
      <p className="summary text-neutral-400 text-base md:text-lg font-normal leading-[1.75] opacity-75">
        I have over 4 years of experience creating dynamic and engaging web and
        mobile applications with animations. With a keen eye for clean and
        modern designs, I bring a unique perspective to front-end development.
        By combining my passion for great design with strong technical
        expertise, I craft seamless and intuitive user experiences using
        advanced front-end technologies.
      </p>
      {/* <p className="summary mt-2 text-neutral-400 text-base md:text-lg font-normal leading-[1.75] opacity-75">
        I&apos;m having a field day wiping out bots on CODM. You can shoot me a
        request if you fancy a br or 1v1 match [ IDN: coldshotg ]
      </p> */}
    </div>
  );
};

export default Summary;
